import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { CreateOrderService } from '../Services/create-order.service';

@Component({
  selector: 'app-payment-error-model',
  templateUrl: './payment-error-model.component.html',
  styleUrls: ['./payment-error-model.component.scss', './payment-error-model.component.rtl.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PaymentErrorModelComponent implements OnInit {
  @Output() cancelErrorModal = new EventEmitter();
  @Input() erroMessage: any;
  constructor(private createOrderService: CreateOrderService) {}

  ngOnInit(): void {
    console.log('trueee', this.erroMessage);
  }

  onClickRefresh(value: any) {
    this.cancelErrorModal.emit(value);
    let obj = {
      showAccordian: 'payment',
    };
    this.createOrderService.setData(obj);
  }
}
